export const departmentUseCases = {
  "marketing": [
    [
      "Qualificação de leads",
      "Lead qualification",
      "Reúne sinais de campanhas e formulários, consulta o CRM e encaminha leads com contexto para o Comercial.",
      "Combines campaign and form signals, checks CRM records and routes leads with context to Commercial."
    ],
    [
      "Campanhas com aprendizado contínuo",
      "Campaign feedback loop",
      "Analisa dúvidas recorrentes em conversas de vendas, prepara pautas e peças e envia o material para aprovação do Marketing.",
      "Analyzes recurring sales questions, drafts campaign topics and assets and submits them for Marketing approval."
    ]
  ],
  "commercial": [
    [
      "Preparação de oportunidades",
      "Opportunity preparation",
      "Consulta o histórico do cliente, identifica informações faltantes e cria tarefas de qualificação antes de encaminhar a oportunidade para Vendas.",
      "Reviews customer history, identifies missing information and creates qualification tasks before handing opportunities to Sales."
    ],
    [
      "Pré-venda com conhecimento técnico",
      "Knowledge-driven presales",
      "Busca especificações e casos internos, reúne respostas para requisitos do cliente e solicita validação técnica antes da proposta.",
      "Retrieves specifications and internal examples, assembles answers to customer requirements and requests technical validation before a proposal."
    ]
  ],
  "sales": [
    [
      "Orçamento conectado ao ERP",
      "ERP-connected quotes",
      "Consulta catálogo, estoque e condições comerciais, prepara o orçamento e encaminha descontos ou exceções para aprovação.",
      "Checks catalogs, inventory and commercial terms, prepares quotes and routes discounts or exceptions for approval."
    ],
    [
      "Da venda à execução",
      "From sale to execution",
      "Ao receber uma ordem aprovada, confere os dados e abre tarefas para Produção, Estoque e Financeiro, acompanhando pendências entre as áreas.",
      "On an approved order, checks its data and opens tasks for Production, Inventory and Finance, tracking cross-team exceptions."
    ]
  ],
  "production": [
    [
      "Materiais para ordens em risco",
      "Materials for at-risk orders",
      "Cruza ordens de produção com saldos e prazos, identifica faltas e prepara solicitações para Compras com revisão do planejador.",
      "Cross-checks production orders against stock and lead times, identifies shortages and prepares purchasing requests for planner review."
    ],
    [
      "Tratamento de não conformidades",
      "Nonconformity handling",
      "Reúne registros de qualidade e procedimentos, abre tarefas de análise e acompanha ações corretivas até a validação do responsável.",
      "Gathers quality records and procedures, creates analysis tasks and tracks corrective actions through owner validation."
    ]
  ],
  "purchasing": [
    [
      "Comparação de cotações",
      "Quotation comparison",
      "Reúne propostas, compara preço, prazo e condições e prepara a recomendação de compra para aprovação, mantendo as fontes consultadas.",
      "Collects proposals, compares price, delivery and terms and prepares a purchasing recommendation for approval with source records."
    ],
    [
      "Acompanhamento de fornecedores",
      "Supplier follow-up",
      "Monitora pedidos e datas previstas, prepara cobranças de posição e sinaliza atrasos para Estoque, Produção e Financeiro.",
      "Monitors purchase orders and expected dates, prepares status requests and flags delays to Inventory, Production and Finance."
    ]
  ],
  "inventory": [
    [
      "Recebimento com conferência",
      "Receipt checking",
      "Compara pedido, documento e registro de recebimento, separa divergências e encaminha a resolução para Compras e Fiscal.",
      "Compares orders, documents and receipt records, isolates discrepancies and routes resolution to Purchasing and Tax."
    ],
    [
      "Separação com tratamento de faltas",
      "Picking shortage handling",
      "Consulta reservas e ordens de venda, identifica itens indisponíveis e coordena tarefas de reposição ou revisão da entrega.",
      "Checks reservations and sales orders, identifies unavailable items and coordinates replenishment or delivery-review tasks."
    ]
  ],
  "logistics": [
    [
      "Torre de controle de entregas",
      "Delivery control tower",
      "Consulta eventos de transporte, identifica atrasos e faltas de comprovante e direciona a próxima ação ao parceiro ou responsável.",
      "Checks transport events, identifies delays and missing proof of delivery and routes the next action to a partner or owner."
    ],
    [
      "Preparação documental da expedição",
      "Dispatch document preparation",
      "Reúne dados de remessa, volumes e transporte, confere pendências do romaneio e encaminha documentos para validação fiscal.",
      "Gathers shipment, package and transport data, checks dispatch-list exceptions and routes documents for tax validation."
    ]
  ],
  "finance": [
    [
      "Cobrança com contexto",
      "Context-aware collections",
      "Consulta títulos e histórico de contatos, prepara lembretes conforme a política e encaminha negociações para o responsável.",
      "Checks receivables and contact history, prepares policy-based reminders and routes negotiations to the owner."
    ],
    [
      "Conciliação e previsão de caixa",
      "Reconciliation and cash forecasting",
      "Cruza títulos, extratos e vencimentos, sugere correspondências e atualiza a visão de pendências para revisão do Financeiro.",
      "Cross-checks invoices, statements and due dates, suggests matches and updates the exception view for Finance review."
    ]
  ],
  "accounting": [
    [
      "Conciliação entre sistemas",
      "Cross-system reconciliation",
      "Reúne movimentos fiscais, financeiros e de estoque, identifica diferenças e abre tarefas com evidências para os responsáveis.",
      "Collects tax, finance and inventory movements, identifies differences and opens evidence-backed tasks for owners."
    ],
    [
      "Fechamento com pendências rastreáveis",
      "Close with traceable exceptions",
      "Acompanha o checklist de fechamento, solicita documentos faltantes e prepara o pacote de evidências para revisão contábil.",
      "Tracks the close checklist, requests missing documents and prepares an evidence package for accounting review."
    ]
  ],
  "it": [
    [
      "Triagem e resolução assistida",
      "Assisted incident resolution",
      "Classifica chamados, consulta a base técnica e propõe passos de resolução; ações que alteram o ambiente seguem aprovação.",
      "Classifies tickets, checks technical knowledge and proposes resolution steps; environment-changing actions require approval."
    ],
    [
      "Monitoramento de integrações",
      "Integration monitoring",
      "Acompanha falhas e eventos dos conectores, reúne contexto técnico e abre incidentes com impacto e responsável definidos.",
      "Monitors connector failures and events, gathers technical context and opens incidents with defined impact and ownership."
    ]
  ],
  "hr": [
    [
      "Onboarding coordenado",
      "Coordinated onboarding",
      "A partir da admissão aprovada, organiza documentos e tarefas para gestor e TI, acompanha pendências e prepara a trilha de capacitação.",
      "Following approved hiring, organizes documents and tasks for managers and IT, tracks exceptions and prepares a training path."
    ],
    [
      "Atendimento interno com políticas",
      "Policy-based employee support",
      "Consulta políticas aprovadas para responder dúvidas, prepara solicitações internas e encaminha situações individuais ao RH com acesso restrito.",
      "Consults approved policies to answer questions, prepares internal requests and routes individual cases to HR with restricted access."
    ]
  ],
  "tax": [
    [
      "Conferência de documentos fiscais",
      "Tax document checking",
      "Extrai dados e compara documentos com pedidos e cadastros, destacando divergências para análise antes do registro no sistema fiscal.",
      "Extracts data and compares documents with orders and master records, highlighting discrepancies for review before tax-system entry."
    ],
    [
      "Pendências de faturamento",
      "Billing exceptions",
      "Reúne dados da ordem de venda e do serviço, verifica campos faltantes e encaminha o pacote para emissão aprovada no sistema integrado.",
      "Gathers sales-order and service data, checks missing fields and routes the package for approved issuance in the integrated system."
    ]
  ]
};
export const departmentRelationships = {
  "marketing": [
    "commercial",
    "sales"
  ],
  "commercial": [
    "marketing",
    "sales",
    "production"
  ],
  "sales": [
    "commercial",
    "production",
    "inventory",
    "finance"
  ],
  "production": [
    "sales",
    "purchasing",
    "inventory"
  ],
  "purchasing": [
    "production",
    "inventory",
    "finance"
  ],
  "inventory": [
    "purchasing",
    "production",
    "logistics",
    "tax"
  ],
  "logistics": [
    "inventory",
    "sales",
    "tax"
  ],
  "tax": [
    "sales",
    "purchasing",
    "finance",
    "accounting"
  ],
  "finance": [
    "sales",
    "purchasing",
    "accounting"
  ],
  "accounting": [
    "tax",
    "finance",
    "inventory"
  ],
  "it": [
    "marketing",
    "commercial",
    "sales",
    "production",
    "purchasing",
    "inventory",
    "logistics",
    "tax",
    "finance",
    "accounting",
    "hr"
  ],
  "hr": [
    "it",
    "commercial",
    "production"
  ]
};
